<!-- Toast para notificaciones -->
<p-toast position="top-right"></p-toast>

<button class="layout-config-button p-link" type="button" (click)="onConfigButtonClick()">
    <i class="pi pi-info"></i>
</button>

<p-sidebar [(visible)]="visible" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" styleClass="layout-config-sidebar w-20rem">

    <!-- Información de la aplicación -->
    <div class="p-3 surface-card border-round shadow-2 mb-3">
        <div class="flex align-items-center gap-2 mb-3 pb-3 border-bottom-1 surface-border">
            <i class="pi pi-info-circle text-primary text-2xl"></i>
            <span class="text-xl font-bold text-900">Información</span>
        </div>

        <div class="flex flex-column gap-3">
            <!-- Nombre de la aplicación -->
            <div class="flex align-items-start gap-2">
                <i class="pi pi-desktop text-600 mt-1"></i>
                <div class="flex flex-column">
                    <span class="text-600 text-xs mb-1">Aplicación</span>
                    <span class="text-900 font-semibold">{{ appName }}</span>
                </div>
            </div>

            <!-- Descripción -->
            <div class="flex align-items-start gap-2" *ngIf="description">
                <i class="pi pi-file-edit text-600 mt-1"></i>
                <div class="flex flex-column">
                    <span class="text-600 text-xs mb-1">Descripción</span>
                    <span class="text-900 text-sm">{{ description }}</span>
                </div>
            </div>

            <!-- Versión -->
            <div class="flex align-items-start gap-2">
                <i class="pi pi-tag text-600 mt-1"></i>
                <div class="flex flex-column">
                    <span class="text-600 text-xs mb-1">Versión</span>
                    <span class="text-900 font-semibold">{{ version }}</span>
                </div>
            </div>


            <!-- Botón de actualización -->
            <div class="mt-2" >
                <button
                    pButton
                    label="Actualizar Aplicación"
                    icon="pi pi-refresh"
                    class="p-button-sm p-button-outlined w-full"
                    (click)="clearCacheAndReload()"
                    pTooltip="Limpiar caché y recargar"
                    tooltipPosition="bottom">
                </button>
            </div>
        </div>
    </div>

    <!-- Temas Personalizados -->
    <div class="p-3 surface-card border-round shadow-2">
        <h5 class="mb-3">Temas (3)</h5>
        <div class="grid">
            <div class="col-4">
                <button
                    class="p-link w-full h-3rem border-round hover:surface-hover transition-colors transition-duration-150"
                    (click)="changeTheme('lara-light-orange', 'light')"
                    pTooltip="Versión 1 Naranja"
                    tooltipPosition="bottom">
                    <img
                        src="assets/logos/logo.png"
                        class="w-2rem h-2rem"
                        alt="Version 1 Naranja" />
                </button>
            </div>
            <div class="col-4">
                <button
                    class="p-link w-full h-3rem border-round hover:surface-hover transition-colors transition-duration-150"
                    (click)="changeTheme('lara-light-pink', 'light')"
                    pTooltip="Versión 2 Rosa"
                    tooltipPosition="bottom">
                    <img
                        src="assets/logos/logov2.png"
                        class="w-2rem h-2rem"
                        alt="Version 2 Rosa" />
                </button>
            </div>
            <div class="col-4">
                <button
                    class="p-link w-full h-3rem border-round hover:surface-hover transition-colors transition-duration-150"
                    (click)="changeTheme('lara-light-purple', 'light')"
                    pTooltip="Versión 3 Morado"
                    tooltipPosition="bottom">
                    <img
                        src="assets/logos/logov3.png"
                        class="w-2rem h-2rem"
                        alt="Version 3 Morado" />
                </button>
            </div>
        </div>
    </div>

</p-sidebar>
